import { render, staticRenderFns } from "./form-status-single.vue?vue&type=template&id=2edf6a96&scoped=true&"
import script from "./form-status-single.vue?vue&type=script&lang=js&"
export * from "./form-status-single.vue?vue&type=script&lang=js&"
import style0 from "./form-status-single.vue?vue&type=style&index=0&id=2edf6a96&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2edf6a96",
  null
  
)

export default component.exports